export default {
  sideMenu: {
    admin: 'Admin',
    brands: 'Brands',
    consumers: 'Consumers',
    dispatch: 'Dispatch',
    laxit: 'LAXit',
    promo: 'Promo',
    providers: 'Providers',
    providerAvailability: 'Provider Availability',
    providerDeductions: 'Provider Deductions',
    providerPayouts: 'Provider Payouts',
    geofences: 'Geofences',
    routing: 'Routing',
    reports: 'Reports',
    transactions: 'Transactions',
    marketingAds: 'Marketing Ads',
    filters: 'Filters',
    settings: 'Settings',
    serviceTypes: 'Service Types',
    pricing: 'Pricing'
  },
  login: {
    ctaDefault: 'LOG IN',
    ctaLoading: 'LOGGING IN...',
    inputEmail: 'Email',
    inputPassword: 'Password',
    forgotLink: 'Forgot Password?',
    errorLogin: 'Invalid email/password combination.'
  },
  consumer: {
    loading: 'Loading...',
    tabLabel: {
      referrals: 'Referrals',
      transactions: 'Transactions',
      bids: 'Bids',
      ratings: 'Ratings',
      creditCard: 'Credit Card',
      promoCodes: 'Promo Codes',
      reservations: 'Reservations'
    },
    call: 'Call',
    personalInfo: {
      label: 'Personal Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      mobile: 'Mobile'
    },
    accountInfo: {
      label: 'Account Information',
      created: 'Account Created',
      referralCode: 'Referral Code',
      numberOfReferral: 'Number Of Referral'
    },
    referrals: {
      search: 'Search',
      export: 'Export',
      id: 'ID',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      mobile: 'Mobile',
      accountCreatedDate: 'Account Created Date',
      lastTrx: 'Last TRX Date',
      totalTrx: 'Total TRX',
      avgRating: 'Avg Rating',
      referralCode: 'Referral Code',
      totalReferral: 'Total Referrals',
      emptyState: 'No Referrals as of yet.'
    },
    transactions: {
      search: 'Search',
      from: 'From',
      to: 'To',
      export: 'Export',
      date: 'Date/Time',
      providerId: 'Provider ID',
      company: 'Company',
      rsvpId: 'RSVP ID',
      invoiceId: 'Invoice ID',
      type: 'Type',
      guestFirstName: 'Guest First Name',
      guestLastName: 'Guest Last Name',
      mobile: 'Mobile',
      creditCard: 'Credit Card',
      bookedThrough: 'Booked Through',
      finalOffer: 'Final Offer',
      chargedAmount: 'Charged Amount',
      promoUsed: 'Promo Used',
      status: 'Status',
      loading: 'Getting transactions...',
      emptyState: 'No Transactions as of yet.'
    },
    ratings: {
      export: 'Export',
      date: 'Date/Time',
      rsvpId: 'Reservation ID',
      provBusinessName: 'Provider Business Name',
      rating: 'Rating',
      msg: 'Message',
      loading: 'Getting the reviews you submit...',
      emptyState: 'No Ratings as of yet.'
    },
    creditCards: {
      export: 'Export',
      addedOn: 'Added On',
      creditCard: 'Credit Card #',
      address: 'Billing Address',
      city: 'Billing City',
      state: 'Billing State',
      zip: 'Billing Zip',
      status: 'Status',
      loading: 'Getting your credit cards...',
      emptyState: 'No Credit Cards as of yet.'
    },
    promoCodes: {
      date: 'Date Redeemed',
      code: 'Promo Code',
      value: 'Value',
      type: 'Type',
      expires: 'Expires',
      amountUsed: 'Amount Used',
      loading: 'Getting your promo codes...',
      emptyState: 'No Promo Codes as of yet.'
    },
    save: 'Save',
    saving: 'Saving...',
    sendResetPassword: 'Send Reset Password',
    sending: 'Sending...',
    passwordSent: 'Success! Password sent!',
    formSuccessful: 'Consumer\'s profile successfully updated.',
    emptyField: 'This field cannot be empty.',
    list: {
      heading: 'Consumer List',
      reactivate: 'Re-Activate',
      disable: 'Disable',
      update: 'update',
      confirmLabel: 'Are you sure you want to {action} selected user(s)?',
      yesUpdate: 'Yes, Update Selected Users',
      statusUpdateLoading: 'Updating status...',
      statusUpdateSuccess: 'Status Update Success!',
      errorMsg: 'Oops! Something went wrong.',
      close: 'Close',
      sendNotif: 'Send Notification',
      pushNotif: 'Push Notification',
      target: 'Target',
      zeroSelected: 'Please select user(s) from the list',
      allUser: 'All Users',
      selectedUser: 'Selected User',
      brands: 'Brands',
      emptyBrand: 'Please select which brand to send notification(s).',
      title: 'Title',
      message: 'Message',
      charLeft: '{count} character(s) left',
      img: 'Image',
      send: 'Send',
      cancel: 'Cancel',
      sendingNotif: 'Sending Notification...',
      sendNotifSuccess: 'Send Notification Success!',
      selectImgFile: 'Please select an image file.',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      mobile: 'Mobile',
      created: 'Created Date',
      lastTrx: 'Last TRX Date',
      totalTrx: 'Total # of TRX',
      referralCode: 'Referral Code',
      referralCount: '# of Referrals',
      referrals: 'Refferals',
      details: 'Details',
      status: 'Status',
      gettingUsers: 'Getting Users...'
    }
  },
  dispatch: {
    driverCall: 'CALL {driverName}',
    driverSend: 'SEND TO {driverName}',
    driverAssign: 'ASSIGN TO {driverName}',
    title: 'DISPATCH',
    rsvpSearchPlaceholder: 'Type and hit enter to search.',
    filterPlaceholder: 'Select a filter.',
    filter: {
      invalidDateRange: 'Invalid Date Range.',
      emptyDate: 'Field cannot be empty.',
      noServiceSelected: 'Please select at least one service.',
      noServiceStatus: 'Please select at least one status.'
    },
    openMap: 'OPEN MAP',
    rsvpTable: {
      id: 'ID',
      status: 'STATUS',
      pickup: 'PICKUP',
      dropoff: 'DROP-OFF',
      pickupTime: 'PICKUP TIME',
      dropoffTime: 'DROPOFF TIME',
      customer: 'CUSTOMER',
      driver: 'DRIVER',
      serviceType: 'SERVICE TYPE',
      pickupType: 'PICKUP TYPE',
      flight: 'FLIGHT',
      ada: 'ADA',
      pax: 'PASSENGERS/<br/>LUGGAGE/<br/>STOPS',
      emptyRsvp: {
        title: 'Use the form at the top.',
        content: 'To start, please select a filter or search for a reservation or package using the form at the top of the page.'
      },
      loadingData: {
        title: 'Loading Reservations',
        content: 'Hold tight! This will be quick.'
      },
      noData: {
        title: 'Oops. Looks like we found nothing.',
        content: 'We can\'t find any reservations or package for that filter. Please use another one from the form at the top.'
      }
    },
    driverTable: {
      id: 'ID',
      name: 'NAME',
      services: 'SERVICES',
      pax: 'PAX',
      license: 'LICENSE',
      status: 'STATUS',
      phone: 'PHONE',
      loading: {
        title: 'Looking for Drivers',
        content: 'Sit tight! We\'re looking for drivers.'
      },
      empty: {
        title: 'Oh no! No one\'s online',
        content: 'It looks like there\'s no available drivers at the moment.'
      }
    },
    mapDetails: {
      package: 'Package',
      reservation: 'Reservation',
      packagePickup: 'FIRST PICKUP ADDRESS',
      packageDropoff: 'LAST DROP-OFF ADDRESS',
      pickup: 'PICKUP ADDRESS',
      dropoff: 'DROP-OFF ADDRESS',
      pickupTime: 'PICKUP TIME',
      flight: 'FLIGHT INFORMATION',
      paxLuggageStops: 'PASSENGER/LUGGAGE/STOPS',
      paxLuggage: 'PASSENGER/LUGGAGE',
      serviceType: 'SERVICE TYPE',
      status: 'STATUS',
      paxName: 'PASSENGER NAME',
      paxEmail: 'PASSENGER EMAIL',
      paxPhone: 'PASSENGER PHONE',
      paxNote: 'PASSENGER NOTE',
      guestInfo: 'GUEST INFORMATION',
      guestName: 'GUEST NAME',
      guestPhone: 'GUEST PHONE',
      guestNone: 'There\'s no guest information for this reservation.',
      guestAdd: 'ADD GUEST INFORMATION',
      driverName: 'DRIVER NAME',
      driverPhone: 'DRIVER PHONE',
      driverEmail: 'DRIVER EMAIL',
      driverInfo: 'DRIVER INFORMATION',
      packageDriverNone: 'There\'s no driver yet for this package.',
      driverNone: 'There\'s no driver yet for this reservation.',
      emptyTitle: 'I have nothing to display right now.',
      emptyContent: 'To begin, please select a reservation/package from the <a href="/#/dispatch/reservations" target="_blank">list</a>.'
    },
    map: {
      filterControls: {
        title: 'Use the form below to look for drivers.',
        labelRadius: 'SEARCH RADIUS (IN MILES):',
        labelServices: 'INCLUDED SERVICE TYPES:',
        labelButton: 'FIND DRIVERS',
        labelLoading: 'Finding Drivers...'
      }
    }
  },
  provider: {
    list: {
      title: 'Provider List',
      filter: {
        search: 'Search',
        type: 'Type',
        all: 'All',
        tcp: 'TCP',
        tnc: 'TNC',
        status: 'Status',
        allNonArchive: 'All (Non-Archived)',
        active: 'Active',
        inactive: 'Inactive',
        pending: 'Pending',
        deactivated: 'Deactivated',
        archived: 'Archived',
        activate: 'Activate',
        deactivate: 'Deactivate',
        archive: 'Archive'
      },
      table: {
        businessName: 'Business Name',
        type: 'Type',
        status: 'Status',
        lastUpdate: 'Last Update',
        city: 'City',
        phone: 'Phone',
        license: 'License',
        insurance: 'Insurance',
        permit: 'Permit',
        cityLicense: 'City License',
        airport: 'Airport',
        drivingRecord: 'Driving Record',
        safetyInspect: 'Safety Inspect',
        lastWeeksEarning: 'Last week\'s Earning',
        avgRating: 'AVG Rating',
        lastLogin: 'Last Login Timestamp',
        bgCheck: 'BG Check',
        archived: 'Archived',
        verified: 'Verified',
        vehicle: 'Vehicle Type'
      },
      notif: {
        header: 'Push Notification',
        allUser: 'All Active User',
        selectedUser: 'Selected User',
        brand: 'Brand',
        title: 'Title',
        message: 'Message',
        send: 'Send',
        cancel: 'Cancel',
        close: 'Close'
      },
      sms: {
        header: 'Send SMS',
        allUser: 'All Active User',
        selectedUser: 'Selected User',
        brand: 'Brand',
        title: 'Title',
        message: 'Message',
        send: 'Send',
        cancel: 'Cancel',
        close: 'Close'
      }
    },
    availability: {
      title: 'Provider Availability',
      businessName: 'Business Name',
      type: 'Type',
      homeSector: 'Home Sector',
      vehicle: 'Vehicle Type',
      phone: 'Phone',
      availableFrom: 'Available From',
      availableUntil: 'Available Until'
    },
    tabLabel: {
      accountDetails: 'Account',
      services: 'Services',
      payout: 'Payouts',
      statistics: 'Statistics',
      availability: 'Availability',
      reviews: 'Reviews',
      notes: 'Notes',
      upcoming: 'Upcoming',
      completed: 'Completed',
      payout: 'Payouts'
    },
    active: 'Active',
    deactive: 'Deactivated',
    modal: {
      toActivate: 'Are you sure you want to activate <b>{provider}</b>?',
      toDeactivate: 'Are you sure you want to deactivate <b>{provider}</b>?',
      no: 'No',
      yes: 'Yes'
    },
    notify: 'Notify',
    sms: 'Send SMS',
    call: 'Call',
    print: 'Print Placard',
    enableServices: 'Enabled Services',
    backgroundSubmitted: 'Background check submitted',
    backgroundPassed: 'Background check passed',
    maxRsvp: 'Max Daily Reservations',
    default: 'Default',
    custom: 'Custom',
    basicInfo: {
      label: 'Basic Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      deviceOS: 'Device Operating System',
      deviceModel: 'Device Model',
      email: 'Email Address',
      language: 'Language',
      mobile: 'Mobile',
      birthday: 'Birthday',
      resetPassword: 'Reset Password',
      password: 'Password',
      repassword: 'Repeat Password'
    },
    vehicleInfo: {
      label: 'Vehicle Information',
      type: 'Vehicle Type',
      year: 'Year',
      capacity: 'Capacity',
      boxCapacity: 'Box Capacity',
      door: 'Door',
      manufacturer: 'Manufacturer',
      model: 'Model',
      identificationNumber: 'Vehicle Identification Number',
      licensePlate: 'License Plate',
      wheelchair: 'Equipped with wheelchair lift.',
      serviceDog: 'Can accommodate a service dog.'
    },
    accountType: {
      label: 'Account Type',
      tcpPermit: 'Do you already have a TCP (Transportation Charter Permit) Permit?',
      type: 'Account Type Override'
    },
    businessInfo: {
      label: 'Business Information',
      name: 'Business Name',
      city: 'City',
      address1: 'Address',
      address2: 'Address 2',
      country: 'Country',
      state: 'State',
      zip: 'ZIP',
      type: 'Type of Business'
    },
    documentation: {
      label: 'Documentation',
      insuranceCompany: 'Insurance Company Name',
      insurancePolicy: 'Insurance Policy #',
      insuranceExp: 'Exp. Date',
      cityLicense: 'City License #',
      cityLicenseExp: 'Exp. Date',
      tcpPermit: 'TCP Permit #',
      tcpPermitExp: 'Exp. Date',
      airportPermit: 'Airport Permit #',
      airportPermitExp: 'Exp. Date',
      driversLicense: 'Driver\'s License #',
      driversLicenseExp: 'Exp. Date',
      vehicleInspection: 'Vehicle Safety Inspection Performed by',
      vehicleInspectionExp: 'Exp. Date',
      drivingRecord: 'Driver\'s Background Check',
      drivingRecordExp: 'Exp. Date'
    },
    eligibility: {
      label: 'Eligibility',
      convicted: 'Have you been convicted, within the past 7 years, of driving under the influence of drugs or alcohol, fraud, sexual offenses, use of a motor vehicle to commit a felony, a crime involving property damage and/or theft, acts of violence, or acts of terror?',
      conviction: 'Have you ever had a conviction for reckless driving, driving under the influence, hit and run, or driving with a suspended or revoked license?',
      ownVehicle: 'Do you personally own this vehicle?',
      modifiedVehicle: 'Has this vehicle ever been significantly modified from factory specifications (e.g. "stretch vehicle", made not street legal, etc.)?',
      driversLicense: 'Have you had your driver\'s license for at least 2 years?'
    },
    agreements: {
      label: 'Agreements',
      declarePenalty: 'I declare under penalty of perjury under the laws of the State of California that I am the driver listed on this application all of the information provided herein is true and correct.',
      agree: 'I  agree to abide by Prime Time Rideshare\'s Rules of Driver Conduct ({conductRules}) as well as the terms of use ({terms}) and privacy policy ({privacy}). I understand that my failure to comply with them may result in the termination of my partnership with Prime Time Rideshare. I understand that Prime Time Rideshare is not a transportation carrier but a tool to connect drivers and riders.',
      signature: 'Signature'
    },
    save: 'Save',
    saving: 'Saving...',
    close: 'Close',
    cancel: 'Cancel',
    addNotes: 'Add Notes',
    statistics: {
      export: 'Export Statistics',
      dateRange: 'Select Date Range',
      hours: 'Hours on Duty',
      bids: 'Bids Made',
      rsvpComplete: 'Reservations Completed',
      rsvpCancelledProv: 'Reservations Cancelled by Provider',
      rsvpCancelledCon: 'Reservations Cancelled by Consumer',
      earned: 'Amount Earned'
    },
    reviews: {
      average: 'Average Review',
      fiveStar: '5-Star Reviews',
      total: 'Total Reviews',
      date: 'Date',
      name: 'Name',
      message: 'Message',
      rating: 'Rating',
      loading: 'Getting Reviews...',
      emptyState: 'No Reviews as of yet...'
    },
    notes: {
      loading: 'Getting Notes...',
      emptyState: 'No notes as of yet.',
      name: 'Name',
      date: 'Date',
      message: 'Message',
      status: 'Status',
      edit: 'Edit',
      delete: 'Delete'
    },
    provReservation: '{provider}\'s Reservations',
    reservations: {
      from: 'from',
      to: 'to',
      id: 'ID',
      pickupTime: 'Pickup Time',
      pickup: 'Pickup',
      dropoff: 'Drop-off',
      service: 'Service',
      customer: 'Customer',
      paxLuggage: 'PAX / Luggage',
      flight: 'Flight',
      driverPayment: 'Driver Payment',
      totalDriverPayment: 'Total Driver Payment',
      loading: 'Getting Reservations...',
      hudson: 'Hudson ID',
      emptyState: {
        upcoming: 'No Upcoming Reservation as of yet.',
        history: 'No Completed Reservation as of yet.'
      }
    },
    formSuccessful: 'Driver\'s profile successfully updated.',
    formFail: 'Fail to update driver\'s profile.',
    emptyField: 'This field cannot be empty.',
    invalidEmail: 'Invalid email format.',
    emptyServices: 'At least one service type for this transportation provider must be chosen before your changes can be saved.',
    sendEmailLabel: 'Send a reset password link to this provider.',
    sendToEmail: 'Send to email',
    sending: 'Sending...',
    orTypeIn: 'OR TYPE-IN',
    passwordNotMatch: 'Password and repeat password doesnt not match.',
    passwordSuccess: 'Success! Driver\'s password has been changed!',
    passwordSent: 'Success! Password sent!',
    upload: 'Upload',
    uploading: 'Uploading...',
    uploadError: 'Oops! Something went wrong. Please try again.',
    documenationNotice: 'Attach scanned or photograped images of your documents below. <br />Please make sure that uploading file types are one of the following formats: <i><b>PDF, JPEG, JPG, GIF, PNG</b></i>.'
  },
  rsvpDetails: {
    rsvpId: 'Reservation {id}',
    tabLabel: {
      basicInfo: 'Basic Information',
      transactions: 'Transactions',
      notes: 'notes',
      activityLogs: 'Activity Logs',
      systemLogs: 'System Logs',
      actionLogs: 'Action Logs',
      dispatchLogs: 'Dispatch Logs'
    },
    tripInformation: {
      label: 'Trip Information',
      brand: 'Brand',
      bookedThrough: 'Source',
      createdOn: 'Created On',
      pickupDate: 'Pickup Date/Time',
      driverPayment: 'Driver Payment',
      seePaymentBreakdown: 'See payment Breakdown',
      paymentBreakdown: 'Payment Breakdown',
      fareAmount: 'Fare Amount',
      bonus: 'Release Bonus',
      paymentBonus: 'Payment Bonus',
      pickupType: 'Pickup Type',
      tip: 'Tip',
      airportFee: 'Airport Fee',
      pickupFee: 'Pickup Fee',
      close: 'Close',
      fare: 'Fare',
      serviceType: 'Service Type',
      pickup: 'Pickup Location',
      dropoff: 'Drop-off Location',
      beThereTime: 'Be There Time',
      distance: 'Distance',
      flightInfo: 'Flight Information',
      terminal: 'Terminal',
      passenger: 'Passenger',
      luggage: 'Luggage',
      notes: 'Consumer Notes',
      serviceArea: 'Service Area',
      rating: 'Rating',
      userReview: 'User Review'
    },
    customerInformation: {
      label: 'Customer Information',
      name: 'Name',
      id: 'Id',
      paidWith: 'Paid With',
      email: 'Email Address',
      mobile: 'Mobile Phone'
    },
    guestInformation: {
      label: 'Guest Information',
      name: 'Name',
      mobile: 'Mobile Phone',
      emptyState: 'This wasn\'t booked for a guest.',
      addBtn: 'Add Guest Information'
    },
    driverInformation: {
      label: 'Driver Information',
      name: 'Name',
      id: 'Id',
      avgRating: 'Average Rating',
      driversLicense: 'Driver\'s License',
      make: 'Make',
      model: 'Model',
      licensePlate: 'License Plate',
      mobile: 'Mobile Phone',
      email: 'Email',
      emptyState: 'There\'s no driver for this reservation.',
      findBtn: 'Find A Driver',
      releaseBtn: 'Release Driver'
    },
    transactions: {
      dateTime: 'Date',
      invoiceId: 'Invoice ID',
      card: 'Card',
      finalOffer: 'Final Offer',
      chargedAmount: 'Charged Amount',
      cancelFee: 'Cancel Fee',
      bonus: 'Bonus',
      promoUsed: 'Promo Used',
      status: 'Status'
    },
    notes: {
      loading: 'Getting Notes...',
      emptyState: 'No notes yet.',
      edit: 'Edit',
      delete: 'Delete',
      deleteMessage: 'Are you sure you want to delete this note?',
      no: 'No',
      yes: 'Yes'
    },
    history: 'History',
    activityLogs: {
      emptyState: 'No activity logs yet.',
      dateTime: 'Date/Time',
      activity: 'Activity',
      placeholder: '<b>{author}</b> made an update last <b>{date}</b> at <b>{time}</b>'
    },
    systemLogs: {
      emptyState: 'No system logs yet.'
    },
    dispatchLogs: {
      emptyState: 'No dispatch logs available'
    },
    cancelRsvp: 'Cancel Reservation',
    sendRefund: 'Send Refund',
    markComplete: 'Mark As Complete',
    addNote: 'Add A New Note',
    sendConfirmationEmail: 'Send Confirmation Email',
    noShow: {
      label: 'Mark as No Show',
      loading: 'Loading...',
      header: 'Passenger No Show',
      bodyConsumer: 'The passenger will be informed that they are a no-show. ',
      bodyProvider: 'The driver will be paid a no-show fee of <b>${fee}</b>.',
      bodyConfirm: 'Do you want to Continue?',
      yes: 'Yes',
      cancel: 'Cancel'
    },
    sendReceiptEmail: 'Send Receipt Email',
    sendCancellationEmail: 'Send Cancellation Email',
    editRsvp: 'Edit this Reservation',
    cancelEdit: 'Cancel edit',
    saveChanges: 'Save Changes',
    flightStatus: {
      loading: 'Updating Flight Status...',
      error: 'Something went wrong on our side. Please try again.',
      status: 'Status',
      departureAirport: 'Departure Airport',
      arrivalAirport: 'Arrival Airport',
      arrivalDate: 'Arrival Time',
      departureDate: 'Departure Time',
      tryAgain: 'Try Again'
    },
    sending: 'Sending...',
    close: 'Close',
    emailSent: 'Email sent.',
    noShowSent: 'No Show is being processed, please refresh the page after a few moments.',
    cancelSuccess: 'Successfully canceled <b>Reservation {rsvpid}</b>.',
    edit: {
      rideRetails: 'Ride Details',
      customerInfo: 'Customer Information',
      aptGate: 'Apartment # / Gate #',
      airline: 'Airline',
      flight: 'Flight',
      wheelchair: 'Wheelchair',
      serviceDog: 'Service Dog',
      services: 'Services',
      priceOverride: {
        label: 'Price Override',
        desc: 'This will override the total trip price including the pickup type fee.'
      },
      driverOverride: {
        label: 'Driver Payment Override',
        desc: 'This will override the payment for provider excluding the pickup type fee.'
      },
      bookingForSomeone: 'Book this reservation for someone else.',
      guestFirstName: 'Guest\'s First Name',
      guestLastName: 'Guest\'s Last Name',
      guestMobile: 'Guest\'s Mobile',
      driverNotes: 'Note to driver',
      paymentSummary: 'Payment Summary',
      fare: 'Fare',
      airportFee: 'Airport Fee',
      tip: 'Tip',
      creditsUsed: 'Credits Used',
      total: 'Total',
      complimentary: 'Complimentary',
      curbside: 'Curbside (free)',
      meetAndGreet: 'Meet & Greet',
      priceChange: 'Your edits have changed the price of this reservation, be sure to inform the customer of the price update.',
      totalFareChange: 'Total fare change from',
      updateSuccessMsg: 'Successfully updated <b>Reservation {id}</b>',
      updatingReservation: 'Updating Reservation...',
      emptyField: 'This field cannot be empty.',
      adminTimeBufferError: 'Dispatch Time must be greater than {min} minutes from current time.',
      selectError: 'Please select from the list.',
      selectService: 'Please select a service for this reservation.',
      serviceRestrictions: 'Certain services are not available due to service area restrictions.',
      zeroValue: 'Value cannot be less than or equal to zero.',
      beyondLimit: 'Bonus should not be greater than ${fare}.'
    }
  },
  rsvpNotes: {
    title: {
      regular: 'Please leave a note.',
      refund: 'Refund Reservation',
      confirmRefund: 'Confirm Refund',
      noShowRefund: 'Confirm No Show Refund'
    },
    payCancellationFee: 'The customer will have to pay a cancellation fee of <b>{amount}</b>. Do you want to charge the cancellation fee?',
    yes: 'Yes',
    no: 'No',
    refundType: 'Refund Type',
    fullRefund: 'Full Refund',
    partialRefund: 'Partial Refund',
    issueCredit: 'Issue Credit',
    additionalCharge: 'Additional Charge',
    refundAmountEmpty: 'Field cannot be empty.',
    notNumber: 'Invalid number.',
    lowNumber: 'Cannot be lower or equal to zero.',
    close: 'Close',
    notes: 'Notes',
    emptyNotes: 'Please put in a note in the text box.',
    charLeft: '{value} character(s) left.',
    status: 'Status',
    new: 'NEW',
    investigation: 'INVESTIGATION',
    resolved: 'RESOLVED',
    cancel: 'Cancel',
    confirm: 'Confirm',
    successCredit: 'Issued credit successfully!'
  },
  transactions: {
    title: 'Transactions',
    gross: 'Gross Revenue',
    ofDateRange: 'of date range',
    creditUsed: 'Credit Used',
    onlineProv: 'Online Providers',
    filter: {
      search: 'Search',
      searchEmpty: 'Selecting "All" from date range requires search keyword.',
      status: 'Status',
      dateRange: 'Date Range',
      all: 'All',
      custom: 'Custom',
      declined: 'Declined',
      cancelled: 'Cancelled',
      promo: 'Promo',
      purchased: 'Purchased',
      authorized: 'Authorized',
      noShow: 'No Show',
      completed: 'Completed',
      refund: 'Refund',
      edited: 'Edited',
      withinDay: 'Within a day',
      monthToDate: 'Month to date',
      lastMonth: 'Last month',
      lastWeek: 'Last week',
      last2Week: 'Last 2 weeks',
      last30Days: 'Last 30 days',
      last60Days: 'Last 60 days',
      last90Days: 'Last 90 days',
      from: 'From',
      to: 'To',
      invalidDateRange: 'Invalid Date Range.',
      emptyDate: 'Field cannot be empty.',
      refresh: 'Refresh',
      export: 'Export'
    },
    list: {
      date: 'Date',
      serviceArea: 'Service Area',
      company: 'Company',
      invoiceId: 'Invoice ID',
      rsvpId: 'RSVP ID',
      pickup: 'Pickup',
      dropoff: 'Dropoff',
      type: 'Type',
      service: 'Service',
      customerName: 'Customer Name',
      email: 'Email',
      mobile: 'Mobile',
      creditCard: 'Credit Card',
      source: 'Source',
      finalOffer: 'Final Offer',
      chargedAmount: 'Charged Amount',
      bonus: 'Bonus',
      promoUsed: 'Promo Used',
      cancelFee: 'Cancel Fee',
      status: 'Status',
      loading: 'Getting Transactions...',
      empty: 'No record found!',
      display: 'Display',
      resultsPerPage: 'results per page.',
      displaying: 'Displaying {min} - {max} of {total}'
    },
    unableToRefund: 'Unable to Refund',
    otherMeans: 'This transaction was paid through means other than a credit card. It cannot be refunded automatically through the system. Please cancel the reservation through the Edit RSVP page.',
    close: 'Close'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js